import { Modal, Space, Table } from 'antd';
import { useInvoiceCFEFormContext } from '../InvoiceCFEFormProvider';
import { ColumnsType } from 'antd/lib/table';
import {
  CardAccreditoEnum,
  CardAccreditoLabel,
  TaxCouponPayment,
  TaxCouponPaymentType,
  TaxCouponPaymentTypeLabel,
  TaxCouponStatus,
} from '@/core/domain/coupon/coupons/coupons.types';
import { DeleteIcon, EditIcon } from '@/components/_common';
import { useTaxCouponPaymentRemove } from '@/core/domain/coupon/coupons/coupons.hooks';
import { useDisclosure } from '@/hooks';
import { useState } from 'react';
import InvoiceCFePaymentEditModal from './InvoiceCFePaymentEditModal';
import formatterPrice from '@/utils/number/formatterPrice';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';

const InvoiceCFePayments: React.FC = () => {
  const { taxCoupon } = useInvoiceCFEFormContext();

  const disabled =
    taxCoupon?.status !== TaxCouponStatus.TYPING ||
    !hasPermissions([Authorities.FISCAL_COUPON_EDIT]);

  const [payment, setPayment] = useState<TaxCouponPayment>();

  const [modalOpen, modalAction] = useDisclosure(false, {
    onClose: () => setPayment(undefined),
  });

  const paymentRemove = useTaxCouponPaymentRemove();

  function confirmPaymentRemove(item: TaxCouponPayment) {
    Modal.confirm({
      title: 'Remover método de pagamento',
      content: `Deseja remover o método de pagamento do tipo "${item.paymentType}"?`,
      okText: 'Remover',
      okType: 'danger',
      onOk: () => {
        if (taxCoupon)
          return paymentRemove.mutateAsync({
            taxCouponId: taxCoupon?.id,
            taxCouponPaymentId: item.id,
          });
      },
    });
  }

  const columns: ColumnsType<TaxCouponPayment> = [
    {
      dataIndex: 'paymentType',
      title: 'Tipo de pagamento',
      render: (type: TaxCouponPaymentType) => TaxCouponPaymentTypeLabel[type],
    },
    {
      dataIndex: ['acquirer', 'type'],
      title: 'Credenciadora do cartão',
      render: (value: CardAccreditoEnum) => CardAccreditoLabel[value] || '-',
    },
    {
      dataIndex: 'value',
      title: 'Valor (R$)',
      align: 'right',
      render: (value) => formatterPrice(value),
    },
    {
      title: 'Ação',
      align: 'right',
      fixed: 'right',
      render: (item) => (
        <Space size="middle">
          <EditIcon
            iconProps={{
              onClick: () => {
                setPayment(item);
                modalAction.open();
              },
            }}
            disabled={disabled}
          />
          <DeleteIcon
            onClick={() => confirmPaymentRemove(item)}
            disabled={disabled}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={taxCoupon?.payments}
        columns={columns}
        scroll={{ x: true }}
        rowKey={(row) => row.id}
        pagination={false}
      />

      <InvoiceCFePaymentEditModal
        payment={payment}
        open={modalOpen}
        onCancel={modalAction.close}
      />
    </>
  );
};

export default InvoiceCFePayments;
